import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor (private _httpClient: HttpClient) { }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  DecimalOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (charCode != 46) {
        return false;
      }
    }
    return true;
  }

  focusInput(input: any) {
    input.focus();
  }

  ConvertDDMMtoMMDD(date: string): string {
    let sDate = date.split('/');
    let newDate = sDate[ 1 ] + '/' + sDate[ 0 ] + '/' + sDate[ 2 ];
    return newDate;
  }

  public getIPAddress() {
    return this._httpClient.get("http://api.ipify.org/?format=json");
  }
}
